export default function Icon({ path, color = "white", link = null, className = "", clickable=true}) {
    return <div onClick={() => (link != null) ? window.open(link, "_blank") : null}
      className={`${clickable ? "transition-transform duration-200 hover:-translate-y-2 cursor-pointer" : ""} ${className}`}
      style={{
        backgroundColor: color,
        WebkitMaskImage: `url(${path})`,
        maskImage: `url(${path})`,
        WebkitMaskRepeat: "no-repeat",
        maskRepeat: "no-repeat",
        WebkitMaskSize: "contain",
        maskSize: "contain",
        WebkitMaskPosition: "center",
        maskPosition: "center",
      }}
    />
}